// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"20":"79261565","194":"797a8653","343":"d025bc39","492":"d025bc39","546":"da0a955c","685":"d025bc39","963":"4bc457d9"}[chunkId] + ".chunk.css";
};